function normalizeBaseUrl(value) {
  return value ? value.replace(/\/+$/, '') : '';
}

function resolveApiBaseUrl({
  nodeEnv = process.env.NODE_ENV,
  configuredBaseUrl = process.env.REACT_APP_API_BASE_URL,
  configuredTunnelBaseUrl = process.env.REACT_APP_TUNNEL_API_BASE_URL,
  hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost',
} = {}) {
  if (configuredBaseUrl) return normalizeBaseUrl(configuredBaseUrl);
  if (nodeEnv === 'production') return 'https://api.picsect.com';
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
    return 'http://localhost:8080';
  }
  return normalizeBaseUrl(configuredTunnelBaseUrl);
}

const apiBaseUrl = resolveApiBaseUrl();

export { apiBaseUrl, resolveApiBaseUrl };
